export let StepState = /*#__PURE__*/function (StepState) {
  StepState["Disabled"] = "disabled";
  StepState["Selected"] = "selected";
  StepState["Enabled"] = "enabled";
  return StepState;
}({});
export const INDICATOR_HEIGHT = 32;
export const getStepState = (step, currentStep, visitedSteps) => {
  if (step === currentStep) return StepState.Selected;
  if (visitedSteps.includes(step)) return StepState.Enabled;
  return StepState.Disabled;
};
export const calculateIndicatorPosition = (element, indicatorHeight) => ({
  top: element.offsetTop + (element.offsetHeight - indicatorHeight) / 2,
  height: indicatorHeight
});